import {useEffect,useRef,useState} from 'react';
import {createApiClient} from '../../shared/http/createApiClient.js';
import {useOrbitAIAvailable} from '../../shared/orbit-ai/availability.js';
import {Evidence} from './InsightPanel.jsx';
const api=createApiClient({auth:true});

export default function PublishedInsights({selection,clientId}) {
 const available=useOrbitAIAvailable(),actions=useRef({});
 const [state,setState]=useState({status:'checking'});
 useEffect(()=>{
  if(!available)return;
  const abort=new AbortController();let timer;
  const send=async(action,extra={})=>{
   try{
    const data=await api.post(selection.endpoint,{view_id:selection.view_id,currency:selection.currency,metrics:selection.metrics,action,...extra},
     {params:{client_id:clientId},signal:abort.signal});
    if(abort.signal.aborted)return;
    setState(data);
    if(['queued','running'].includes(data.status))timer=setTimeout(()=>send('result',{artifact_id:data.id}),2000);
   }catch(error){if(!abort.signal.aborted)setState({status:'failed',error:error.message});}
  };
  setState({status:'checking'});send('lookup');
  actions.current.generate=()=>{clearTimeout(timer);setState({status:'queued'});send('generate',{regenerate:crypto.randomUUID()});};
  return ()=>{abort.abort();clearTimeout(timer);};
 },[available,clientId,selection.view_id,selection.currency,selection.endpoint,JSON.stringify(selection.metrics)]);
 if(!available)return null;
 const busy=['checking','queued','running'].includes(state.status);
 return <section className="dashboard-ai-panel o-panel" aria-label="AI insights">
  <div className="dashboard-ai-header"><div><h2>AI insights</h2><p className="o-note">Based on all {selection.matched_rows.toLocaleString()} matching records.</p></div>
   <button type="button" className="o-btn o-btn-sm" disabled={busy||!selection.matched_rows} onClick={()=>actions.current.generate?.()}>{state.status==='succeeded'?'Regenerate':'Generate insights'}</button>
  </div>
  {busy&&<p className="o-note" role="status">{state.status==='checking'?'Checking saved insights…':'Analyzing the complete selection…'}</p>}
  {state.status==='failed'&&<p className="o-state o-error" role="alert">{state.error||'Unable to load insights. Retry explicitly.'}</p>}
  {state.status==='succeeded'&&<div><p>{state.insights.summary}</p>{state.insights.findings.map((finding,index)=><article key={index}>
   <h3>{finding.title}</h3><p>{finding.observation}</p><p><strong>{finding.explanation_kind==='hypothesis'?'Possible explanation':'Observed driver'}: </strong>{finding.explanation}</p>
   <p><strong>Next action: </strong>{finding.action}</p><Evidence finding={finding} result={state}/>
  </article>)}{state.insights.limitations.map((note,index)=><p className="o-note" key={index}>{note}</p>)}</div>}
 </section>;
}
